module.exports = __webpack_public_path__ + "01ea978f/img/comments-icon.fdec7fdb.svg";